export default (function () {
  var query = {};
  var hash = {};
  window.location.hash.replace(/#.*?\?/, '').split('&').forEach(function (i) {
    hash[i.split('=')[0]] = i.split('=')[1];
  });
  window.location.search.replace('?', '').split('&').forEach(function (i) {
    query[i.split('=')[0]] = i.split('=')[1];
  });
  return [{
    pageId: "" + window.location.pathname + window.location.hash + "-1",
    query: query,
    hash: hash
  }];
});